import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import DropdownView from "./DropdownView";
import ResetUjianModal from "../../../components/ResetUjianModal";
import {SelectPanel} from "@khanacademy/react-multi-select";
import Dropzone from "react-dropzone";

class Score extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSiswa: [],
            dataExport   : [],
            dataParticipant: [],
            exam_cat_id: 0,
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isButtonLoading: false,
            isModalShow: false,
            modalEditShow:false,
            examId:"",
            nama:"",
            participant_id:"",
            siswaSelected:[],
            file: [],
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModalEdit = this.toggleModalEdit.bind(this);
        this.handleSelected = this.handleSelected.bind(this);

    }

    handleDeleteFile(index) {

        const copiedStateFiles = [
            ...this.state.file
        ]

        copiedStateFiles.splice(index, 1)

        this.setState({
            file: copiedStateFiles
        })
    }

    onDrop(files) {
        const newState = this.state.file.concat(files)
        this.setState({
            file: newState
        });
    }

    handleSelected(siswaSelected) {
        this.setState({siswaSelected});

    }

    toggleModalEdit(e,f) {
        this.setState({
            entry_id : e,
            user_id: f,
            modalEditShow: !this.state.modalEditShow
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        const newState = {
            [name]: value
        }

        this.setState(
            newState,
            () => this.loadData()
        )
    }

    loadData() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            cari: this.state.nama,
            exam_id:this.props.match.params.exam_id,
            participant_id:this.state.participant_id
        });

        axios({
            method: "post",
            url: "ujian/siswa-part?" + params
        })

            .then(response => {
                const result = response.data;

                if (result.success === true) {
                    this.setState({
                        dataSiswa: result.data,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataParti(){
        this.setState({ isLoading: true });
        const params = qs.stringify({
            locale:"id",
            platform:"web",
            exam_id:this.props.match.params.exam_id
        });

        axios({
            method: "post",
            url: "/kelas?" + params
        })
            .then(response => {
                const result = response.data;

                if (result.success) {
                    const dataParticipant = result.data.map(item => ({
                        key: item.kelas_id,
                        value: item.kelas_nama
                    }));

                    this.setState({
                        dataParticipant,
                        isLoading: false
                    });
                } else {
                    Alert.error(result.text);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    componentDidMount() {
        this.loadData();
        this.loadDataParti();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.nama !== this.state.nama) {
            this.loadData()
        }
    }

    handleSubmit() {
        let formData = new FormData();
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        if ([]) {
            formData.append('file', this.state.file[0])
        }else{
            formData.append('file', '')
        }

        formData.append('kelas_id', this.state.participant_id);
        formData.append("user_id", localStorage.SISMART_USER_ID);
        formData.append("siswaSelect", this.state.siswaSelected);

        const url = "ujian/cetak-kartu";

        this.setState({ isButtonLoading: true });

        axios.post(url, formData, config)
            .then(response => {
                const result = response.data;
                if (result.success) {
                    this.setState({
                        isButtonLoading : false
                    },()=>{
                        Alert.success(result.message);
                        this.props.history.push(`/setting/arsip`)
                    });
                }
                else {
                    if (Array.isArray(result.message)) {

                        result.message.map(item => {
                            Alert.error(item)
                            return true
                        })
                    }
                    else {
                        Alert.error(result.message)
                    }
                    this.setState({ isButtonLoading: false })
                }
            })

            .catch(error => {
                console.log("ERROR", error)
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isButtonLoading: false })
            })
    }

    render() {
        const dataSiswa = this.state.dataSiswa.map(item => ({
            value: item.siswa_id,
            label: item.user_nama+" - "+item.kelas_nama
        }));

        const {siswaSelected} = this.state;

        return (
            <div>
                <ResetUjianModal
                    modalHeaderText="Reset Ujian"
                    modalBodyText = "Anda yakin ingin mereset ujian ini?"
                    modalSubmitText="Reset Ujian"
                    user_id = {this.state.user_id}
                    entry_id = {this.state.entry_id}
                    toggleModalEdit={this.toggleModalEdit}
                    isShow={this.state.modalEditShow}
                />
                <div className="card" >
                    <div className="card-block">
                        <div className="col-md-12 form-group row">
                            <div className="col-md-6">
                                <DropdownView
                                    handleChange={this.handleChange}
                                    stateName="participant_id"
                                    label="Pilih Kelas Peserta"
                                    disabled={this.props.mode === 'Edit' ? true : false}
                                    items={this.state.dataParticipant}
                                    value={this.state.participant_id}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    name="nama"
                                    type="text"
                                    className="form-control"
                                    placeholder="Ketikkan Nama Pengguna..."
                                    value={this.state.nama}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card" >
                    <div className="card-block">
                        <div>
                            <label className="col-md-12 form-control-label">
                                <strong>*Upload file zip disini</strong><br/>
                                <strong>*Pastikan nama file menggunakan NISN</strong><br/>
                            </label>
                            <div className="form-group row">
                                <div className="col-md-12">
                                    <Dropzone
                                        onDrop={this.onDrop.bind(this)}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            border: "2px dashed #e9e9e9",
                                            padding: "20px 30px",
                                            color: "#888",
                                            cursor: "pointer",
                                            textAlign: "center",
                                            marginBottom: "15px"
                                        }}
                                    >
                                        Klik atau drop file disini untuk mengupload file
                                    </Dropzone>

                                    <ul>
                                        {
                                            this.state.file.map((item, index) =>
                                                <li key={"file" + index} style={{ marginBottom: "10px" }}>
                                                    {item.name} {" "}
                                                    <button
                                                        title="Hapus"
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => this.handleDeleteFile(index)}
                                                        type="button"
                                                    >
                                                        <i className="fa fa-remove"></i>
                                                    </button>
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <button
                            type="button"
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Upload"}
                        </button>{" "}
                        <button
                            type="button"
                            className="btn btn-md btn-danger"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={() => this.props.history.goBack()}
                        >
                            Batal
                        </button>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">Siswa</div>
                    <div className="card-block">
                        {this.state.isLoading ? (
                            "Memuat Data..."
                        ) : this.state.dataSiswa.length === 0 ? (
                            "Data Kosong..."
                        ) : (
                            <div>
                                <div className="card">
                                    <div>
                                        <SelectPanel
                                            options={dataSiswa}
                                            onSelectedChanged={this.handleSelected}
                                            hasSelectAll
                                            focusIndex={1}
                                            selected={siswaSelected}
                                            disableSearch={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        );
    }
}

export default Score;



// WEBPACK FOOTER //
// ./src/views/Exam/KartuUjian/Detail.js